/**
 * @deprecated This object is being removed in V6+, February 2025, in favor of the `space` object in `smartsheet/design-tokens`.
 */
export const sizes = {
  xxSmall: 4,
  xSmall: 8,
  small: 12,
  medium: 16,
  large: 24,
  xLarge: 32,
  xxLarge: 48
};
/**
 * @deprecated This object is being removed in V6+, February 2025, in favor of the `space` object in @smartsheet/design-tokens.
 */
export const modalSizes = {
  small: 320,
  medium: 480,
  large: 640,
  xLarge: 720
};
//# sourceMappingURL=spacing.js.map